import type { ReactNode } from "react";
import { cn } from "../lib/cn";
import type { RoomStatus } from "../lib/types";

export function Badge({
  children,
  tone = "neutral",
  className,
}: {
  children: ReactNode;
  tone?: "neutral" | "violet" | "cyan" | "emerald" | "amber" | "rose";
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium tracking-wide",
        {
          "border-white/10 bg-white/[0.04] text-zinc-400": tone === "neutral",
          "border-violet-400/20 bg-violet-500/10 text-violet-200":
            tone === "violet",
          "border-cyan-400/20 bg-cyan-500/10 text-cyan-200": tone === "cyan",
          "border-emerald-400/20 bg-emerald-500/10 text-emerald-200":
            tone === "emerald",
          "border-amber-400/20 bg-amber-500/10 text-amber-200":
            tone === "amber",
          "border-rose-400/20 bg-rose-500/10 text-rose-200": tone === "rose",
        },
        className,
      )}
    >
      {children}
    </span>
  );
}

export function RoomStatusBadge({ status }: { status: RoomStatus }) {
  if (status === "live") {
    return (
      <Badge tone="rose">
        <span className="relative flex size-1.5">
          <span className="live-pulse absolute inline-flex size-full rounded-full bg-rose-400" />
          <span className="relative inline-flex size-1.5 rounded-full bg-rose-400" />
        </span>
        LIVE
      </Badge>
    );
  }
  if (status === "waiting") {
    return (
      <Badge tone="amber">
        <span className="size-1.5 rounded-full bg-amber-400" />
        Ожидание
      </Badge>
    );
  }
  return (
    <Badge>
      <span className="size-1.5 rounded-full bg-zinc-500" />
      Завершена
    </Badge>
  );
}

export function ConnectionTypeBadge({
  transport,
}: {
  transport: "p2p" | "relay" | "unknown" | null | undefined;
}) {
  if (transport === "relay") {
    return <Badge tone="amber">TURN Relay</Badge>;
  }
  if (transport === "p2p") {
    return <Badge tone="emerald">Direct P2P</Badge>;
  }
  return <Badge>Соединение…</Badge>;
}
